



























































































import Vue from 'vue'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

// $t('error.submitPassword')
// $t('error.passwordNotMatching')
// $t('error.submitName')

export default Vue.extend({
  name: "UserEdit",
  data(){
    return {
      nameDraft: this.$store.getters.organizationUser?.name || "",
      emailSettingsDraft: {
        allowOrgNotifications: this.$store.getters.organizationUser?.settings.email.allowOrgNotifications
      },
      passwordDraftOld: "",
      passwordDraft: "",
      passwordConfirmDraft: "",
      isLoadingPasswordSubmit: false,
      isPasswordSubmitNotMatching: false,
      isPasswordSubmitSuccess: false,
      isLoadingEmailSubmit: false,
    }
  },
  computed: {
    organization(){ return this.$store.getters.organization },
    organizationUser(){ return this.$store.getters.organizationUser },
    userId(){ return this.$store.getters.userId },
    userEmail(){ return this.$store.getters.userEmail },
  },
  methods: {
    async handlePasswordSubmit(){
      try {
        this.isLoadingPasswordSubmit = true
        this.isPasswordSubmitNotMatching = false
        this.isPasswordSubmitSuccess = false
        // Check if passwords match:
        if(this.passwordDraft != this.passwordConfirmDraft){
          this.isPasswordSubmitNotMatching = true
          return
        }

        await this.$store.dispatch('updatePassword', {
          oldPassword: this.passwordDraftOld,
          newPassword: this.passwordDraft,
        })

        this.passwordDraftOld = ""
        this.passwordDraft = ""
        this.passwordConfirmDraft = ""
        this.isPasswordSubmitSuccess = true
      } catch (error) {
        console.error(error)

        if(error.code == "auth/signin-failed")  alert(this.$t('error.oldPasswordIncorrect'))
        else                                    alert(this.$t('error.submitPassword'))
      } finally {
        this.isLoadingPasswordSubmit = false
      }
    },
    async handleEmailSettingsSubmit(event: any){
      try {
        this.isLoadingEmailSubmit = true
        
        const newUser = Object.assign({}, this.organizationUser)
        newUser.settings.email = this.emailSettingsDraft

        await this.$store.dispatch('updateUser', newUser)
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoadingEmailSubmit = false
      }
    },
  },
  components: {
    AppHeader,
    AppFooter,
    UiCard,
    UiButton,
    UiIcon,
  },
})
